module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAWBAMAAADQs7pMAAAAD1BMVEUAAADIyM3a2t3U1NjIyM08HfDUAAAABHRSTlMAFwYM9RY4wgAAADpJREFUCNdjYGBgUmCAAUUhOFPEUQEu6gIXZiJV2AAhLAhjMrs4CqAwEQoQ2hCGIawgKIjpdJggwpsAcBIJZfQUu0sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightcorner.png
// module id = D4Yq
// module chunks = 39